<div class="simple-bar-chart-container"id="chart-container" style="width: 100%; height: 255px;" #chartContainer></div>